/*
@author : Christophe Bernard
@contact : monsieurbergall@gmail.com
*/


import ComponentEmphase from './js/ComponentEmphase';
import ComponentEngagement from './js/ComponentEngagement';
import ComponentInfographie from './js/ComponentInfographie';
import ComponentKeywords from './js/ComponentKeywords';
import ComponentNumbers from './js/ComponentNumbers';
import ComponentTxtImg from './js/ComponentTxtImg';
import ComponentVideoDouble from './js/ComponentVideoDouble';
import ComponentIntro from './js/Intro';
import { MenuMobile, MenuSticky } from './js/Menu';
import Popins from './js/Popins';
import ComponentSlider from './js/slider';



const main = {
  init: function () {
    window.addEventListener("readystatechange", this.load(document.readyState));

  },
  load: (readyState) => {
    switch (readyState) {
      case "loading":
        document.body.style.opacity = 0

      case "load":
        main.startComponents()
      case "interactive":
      case "loaded":
      case "complete":
        document.body.style.opacity = 1
      default:
        break;
    }
  },

  startComponents(){

        // POPINS
        const compPopins = document.querySelectorAll(".c-popins");
        if (compPopins.length > 0) {
          compPopins.forEach(pop =>
            new Popins(pop.dataset.popinId))
        }

        // INTRO
        ComponentIntro();

        // COMPOSANTS TXT IMG
        ComponentTxtImg()
        
        // COMPOSANT BLOC HEADER
        // gestion des interactions du menu
        new MenuMobile() 
        new MenuSticky()

        // // COMPOSANT BLOC SLIDERS
        ComponentSlider();

        // COMPOSANT BLOC NUMBERS
        ComponentNumbers();

        // COMPOSANT EMPHASE
        ComponentEmphase();

        // COMPOSANT Engagement
        ComponentEngagement();

        // COMPOSOANT KEYWORDS
        ComponentKeywords();

        // COMPOSANT VIDEO DOUBLE
        ComponentVideoDouble();

        // INFOGRAPHIE
        ComponentInfographie()

  }
};

export default main;
